"use client";

import { Suspense, useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { TopSection } from "../custom/containers";
import Footer from "../custom/footer-section";

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const searchParams = useSearchParams();
  const store: string = searchParams.get("store") || "bst_group";
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const branch = (await import("branch-sdk")).default;
      branch.init(process.env.NEXT_PUBLIC_BRANCH_KEY || "", {}, (err, data) => {
        // Safely check for the "+clicked_branch_link" property

        const isClicked =
          typeof data?.data_parsed === "object" &&
          data?.data_parsed !== null &&
          (data.data_parsed as Record<string, unknown>)["+clicked_branch_link"];

        if (isClicked) {
          setLoading(true);
          const dataParsed =
            data?.data_parsed &&
            (data.data_parsed as { web_url: string; store: string });
          const webUrl = dataParsed?.web_url;

          if (webUrl) {
            window.location.href = `/download/?store=${dataParsed?.store}`;
          }
        } else {
          setLoading(false);
        }
      });
    })();
  }, []);

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <>
      <main className="grow max-w-[1134px] mx-auto w-full flex flex-col lg:gap-8 sm:gap-6 gap-4 rounded-[24px] sm:pb-6 py-4">
        <TopSection />
        {children}
      </main>
      <Footer store={store} />
    </>
  );
};

const LoadingComponent = () => (
  <div className="w-screen h-screen flex items-center justify-center">
    <div className="w-8 h-8 border-[3px] border-t-[3px] border-gray-400 border-t-primary rounded-full animate-spin" />
  </div>
);

const OuterWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Suspense fallback={<LoadingComponent />}>
      <Wrapper>{children}</Wrapper>
    </Suspense>
  );
};

export default OuterWrapper;
